import { useCallback, useEffect, useState } from 'react';
import useScript from '../../../_hooks/useScript';

const ADOBE_CLIENT_ID = process.env.ADOBE_CLIENT_ID;

export function useAdobeView(
  divId: string,
): [AdobeDC.View | undefined, { isLoading: boolean; isError: boolean }] {
  const [scriptIsLoaded, scriptHasError] = useScript(
    'https://documentcloud.adobe.com/view-sdk/main.js',
  );

  const [adobeView, setAdobeView] = useState<AdobeDC.View>();

  const onAdobeDCReady = useCallback(() => {
    if (ADOBE_CLIENT_ID) {
      setAdobeView(
        new AdobeDC.View({
          clientId: ADOBE_CLIENT_ID,
          divId,
        }),
      );
    }
  }, [divId]);

  useEffect(() => {
    if (scriptIsLoaded) {
      if (typeof AdobeDC === 'undefined') {
        document.addEventListener('adobe_dc_view_sdk.ready', onAdobeDCReady);

        return () => document.removeEventListener('adobe_dc_view_sdk.ready', onAdobeDCReady);
      } else {
        onAdobeDCReady();
      }
    }

    return () => {};
  }, [scriptIsLoaded, onAdobeDCReady]);

  return [adobeView, { isLoading: !adobeView, isError: scriptHasError }];
}
